module.exports = __webpack_public_path__ + "static/media/slider180deg.54638011.jpeg";